import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  CanAccess,
  NavbarSecondary as NavbarSecondaryContainer,
} from '@unimed-fesp/components';
import {
  DropdownContainer,
  DropdownItens,
  DropdownItensLegacy,
  NavbarItemContainer,
  NavbarItemDropdownContainer,
  NavbarLegacyLink,
} from './styles';

import { TipoPerfilUsuarioEnum } from '../../../enums';

// #region Import assets
import { ReactComponent as BeneficiarioIcone } from '../../../assets/icons/beneficiarioIcon.svg';
import { ReactComponent as ConfiguracaoIcone } from '../../../assets/icons/configuracaoIcon.svg';
import { ReactComponent as GestaoIcone } from '../../../assets/icons/gestaoIcon.svg';
import { ReactComponent as ListasIcone } from '../../../assets/icons/listasIcon.svg';
import { ReactComponent as SegundaViaIcone } from '../../../assets/icons/segundaViaCartaoIcon.svg';
import { ReactComponent as VisaoGeralIcone } from '../../../assets/icons/visaoGeralIcon.svg';
// #endregion

import { legacyRoutes } from '../../../routes/legacyRoutes';

import useOutsideClick from '../../../utils/useOutsideClick';
import { isAdmin, isContratanteNestle } from '../../../utils/userRole';

function NavbarSecondary() {
  const { usuario } = useSelector((state) => state.auth);
  const refDropdown = useRef();
  const refDropdownBeneficiary = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownBeneficiary, setShowDropdownBeneficiary] = useState(false);

  const handleDropdownBeneficiary = (e) => {
    if (e.target) setShowDropdownBeneficiary(!showDropdownBeneficiary);
  };
  const handleShowDropdownItens = (e) => {
    if (e.target) setShowDropdown(!showDropdown);
  };

  useOutsideClick(refDropdown, () => {
    if (showDropdown) setShowDropdown(false);
  });

  useOutsideClick(refDropdownBeneficiary, () => {
    if (showDropdownBeneficiary) setShowDropdownBeneficiary(false);
  });

  return (
    <NavbarSecondaryContainer>
      <NavbarLegacyLink href={legacyRoutes.Home.url}>
        <VisaoGeralIcone />
        Visão Geral
      </NavbarLegacyLink>
      {usuario.role === TipoPerfilUsuarioEnum.returnNameForName.Adm ? (
        <NavbarItemDropdownContainer onClick={handleShowDropdownItens}>
          <ListasIcone />
          Listas
          <DropdownContainer ref={refDropdown} showDropdown={showDropdown}>
            <DropdownItens to="/novo/lista">
              Listas de movimentação
            </DropdownItens>
            <DropdownItens to="/novo/listas-rpa">listas de RPA</DropdownItens>
            <DropdownItens to="/novo/listas-massa-inicial">
              Listas de massa inicial
            </DropdownItens>
          </DropdownContainer>
        </NavbarItemDropdownContainer>
      ) : (
        <NavbarItemContainer to="/novo/lista">
          <ListasIcone />
          Listas
        </NavbarItemContainer>
      )}

      <NavbarLegacyLink href={legacyRoutes.Segundavia.url}>
        <SegundaViaIcone />
        2° via de cartão
      </NavbarLegacyLink>
      {/*  <NavbarItemContainer to="/novo/segunda-via">
        <SegundaViaIcone />
        2° Via de Cartão
      </NavbarItemContainer> */}

      {isContratanteNestle(usuario) ? (
        <NavbarItemContainer to="/novo/beneficiarios-nestle">
          <BeneficiarioIcone />
          Beneficiários
        </NavbarItemContainer>
      ) : (
        <NavbarLegacyLink href={legacyRoutes.ConsultaBeneficiarios.url}>
          <BeneficiarioIcone />
          Beneficiários
        </NavbarLegacyLink>
      )}

      {isContratanteNestle(usuario) ? (
        <NavbarItemContainer to="/novo/relatorio-nestle">
          <ListasIcone />
          Relatórios
        </NavbarItemContainer>
      ) : (
        !isContratanteNestle(usuario.role) &&
        !isAdmin(usuario.role) && (
          <NavbarItemDropdownContainer onClick={handleDropdownBeneficiary}>
            <ListasIcone />
            Relatórios
            <DropdownContainer
              ref={refDropdownBeneficiary}
              showDropdown={showDropdownBeneficiary}
              isBeneficiary
            >
              <DropdownItens to="/novo/relatorio-beneficiario">
                Relatório Beneficiários
              </DropdownItens>

              <DropdownItens to="/novo/processamento-relatorio">
                Acompanhar Relatórios
              </DropdownItens>
            </DropdownContainer>
          </NavbarItemDropdownContainer>
        )
      )}

      <CanAccess
        checkRole={{
          Administrador: TipoPerfilUsuarioEnum.returnNameForName.Adm,
        }}
        userRole={usuario.role}
      >
        <NavbarItemContainer to="/novo/gestao">
          <GestaoIcone />
          Gestão
        </NavbarItemContainer>
      </CanAccess>
      <NavbarItemContainer to="/novo/configuracoes">
        <ConfiguracaoIcone />
        Configurações
      </NavbarItemContainer>
    </NavbarSecondaryContainer>
  );
}

export default NavbarSecondary;
